<template>
    <MainContentTabs
        :tabs="[
            {tab : 'precios-abonos', nombre: 'Configurar precios de los abonos'},
            {tab : 'vouchers', nombre: 'Configurar cupones de descuento'},
            ...(teatro.invitaciones_para_abonados === 1 ? [{tab : 'invitaciones', nombre: 'Configurar invitaciones abonados'}] : [])
        ]"
        initialTab="precios-abonos"
    >
        <template slot="precios-abonos">
            <TabPrices v-if="lista.place"/>
            <TabPricesSinRecinto v-else/>
        </template>
        <template slot="vouchers">
            <TabVouchers/>
        </template>
        <template slot="invitaciones">
            <TabInvitaciones />
        </template>
    </MainContentTabs>
</template>

<script>

    import TabPrices from './tabs/TabPrices.vue';
    import MainContentTabs from '@/components/backend/components/MainContentTabs.vue';
    import TabVouchers from './tabs/TabVouchers.vue';
    import TabPricesSinRecinto from './tabs/TabPricesSinRecinto.vue';
    import TabInvitaciones from './tabs/TabInvitaciones.vue';

    export default {
        components: {
            TabPrices, MainContentTabs, TabVouchers, TabPricesSinRecinto, TabInvitaciones
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>